import { Chip, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AttributionSource } from "@rossum/upcloud-costs-shared";

/** An attributed value with its source as a tooltip; unassigned values stand out. */
export function AttributionValue({ value, source }: { value: string | null; source: AttributionSource }) {
    const { t } = useTranslation();
    return (
        <Tooltip title={t(`source.${source}`)}>
            <Chip
                size="small"
                variant={source === "UNASSIGNED" ? "outlined" : "filled"}
                color={source === "UNASSIGNED" ? "warning" : "default"}
                label={value ?? t("resource.unassigned")}
            />
        </Tooltip>
    );
}
